import { BaseOption } from 'ui/selects';
import { Day, RecurrenceScheduleType } from './Scheduler.types';

export const SCHEDULE_DATE_TEST_ID = 'scheduler-date-time';
export const SCHEDULE_RECURRENCE_TEST_ID = 'scheduler-recurrence';
export const SCHEDULE_RECUR_DAYS_TEST_ID = 'scheduler-recurrence-custom';

export const SCHEDULE_RECURRENCE_OPTIONS: BaseOption<string | number>[] = [
  {
    id: RecurrenceScheduleType.DoNotRepeat,
    value: RecurrenceScheduleType.DoNotRepeat,
    label: "Don't repeat",
  },

  { id: RecurrenceScheduleType.Daily, value: RecurrenceScheduleType.Daily, label: 'Daily' },

  { id: RecurrenceScheduleType.Weekly, value: RecurrenceScheduleType.Weekly, label: 'Weekly' },

  {
    id: RecurrenceScheduleType.BiWeekly,
    value: RecurrenceScheduleType.BiWeekly,
    label: 'Every two weeks',
  },

  {
    id: RecurrenceScheduleType.ThirtyDays,
    value: RecurrenceScheduleType.ThirtyDays,
    label: 'Every 30 days',
  },
  // Requires BE work WF-5240
  // {
  //   id: RecurrenceScheduleType.FirstOfTheMonth,
  //   value: RecurrenceScheduleType.FirstOfTheMonth,
  //   label: 'First of the month',
  // },

  // {
  //   id: RecurrenceScheduleType.FifteenTheOfTheMonth,
  //   value: RecurrenceScheduleType.FifteenTheOfTheMonth,
  //   label: '15th of the month',
  // },

  // {
  //   id: RecurrenceScheduleType.LastOfTheMonth,
  //   value: RecurrenceScheduleType.LastOfTheMonth,
  //   label: 'Last of the month',
  // },

  {
    id: RecurrenceScheduleType.Custom,
    value: RecurrenceScheduleType.Custom,
    label: 'Custom',
  },
];

const MIN_RECUR_DAYS = 1;
const MAX_RECUR_DAYS = 100;

export const RECUR_DAYS_RANGE = {
  min: MIN_RECUR_DAYS,
  minMessage: `The minimum is ${MIN_RECUR_DAYS} day.`,
  max: MAX_RECUR_DAYS,
  maxMessage: `The maximum is ${MAX_RECUR_DAYS} days.`,
};

export const SEND_ON_DAYS_OPTIONS = [
  {
    id: Day.Monday,
    label: 'Mon',
  },
  {
    id: Day.Tuesday,
    label: 'Tue',
  },
  {
    id: Day.Wednesday,
    label: 'Wed',
  },
  {
    id: Day.Thursday,
    label: 'Thu',
  },
  {
    id: Day.Friday,
    label: 'Fri',
  },
  {
    id: Day.Saturday,
    label: 'Sat',
  },
  {
    id: Day.Sunday,
    label: 'Sun',
  },
];

export const RECURRENCE_SCHEDULE_TYPES_WITH_SKIP_ON_DAYS = [
  RecurrenceScheduleType.Daily,
  RecurrenceScheduleType.Custom,
  RecurrenceScheduleType.ThirtyDays,
];

export const TIME_FORMAT = 'hh:mm A';

export const MAX_OFFSET = 60;
